import React from "react";
import "./style.css";

const ScheduleComponent = () => {
  return (
    <div className="schedule-wrapper">
      <h2 className="schedule-heading black-text-clip">
        Locations: Indoors and outdoors Holy Family and Jumpshotz
      </h2>
      <div className="schedule-main-table">
        <div className="schedule-main-header">
          <div className="schedule-thursday black-text-clip">EVERY THURSDAY</div>
          <div className="schedule-saturday black-text-clip">EVERY SATURDAY</div>
          <div className="schedule-sunday black-text-clip">EVERY SUNDAY</div>
        </div>
        <div className="schedule-main-body-time">
          <div className="schedule-main-body">
            <div className="schedule-thursday-body black-text-clip">
              <p>
                <strong>Bowling – 3:45pm–4:45pm</strong>
              </p>
            </div>
            <div className="schedule-saturday-body black-text-clip">
              <p>
                <strong>
                  Ages: 12 and under (Littles)
                  <br />
                  Track & Field 12:00–12:45PM
                  <br />
                  Football 12:45–1:30PM
                </strong>
              </p>
              <br />
              <p>
                <strong>
                  Ages: 13 and up (Bigs)
                  <br />
                  Track & Field 1:30–2:15PM
                  <br />
                  Football 2:15 – 3:00PM
                </strong>
              </p>
            </div>
            <div className="schedule-sunday-body black-text-clip">
              <p>
                <strong>
                  Ages: 12 and under (Littles)
                  <br />
                  Soccer 9:30–10:15 AM
                  <br />
                  Basketball 10:15–11:00 AM
                </strong>
              </p>
              <br />
              <p>
                <strong>
                  Ages: 13 and up (Bigs)
                  <br />
                  Soccer 11:00–11:45 AM
                  <br />
                  Basketball 11:45 AM–12:30 PM
                </strong>
              </p>
            </div>
          </div>
          <div className="schedule-bwc-timings">
            <p className="schedule-bwc-text black-text-clip">
              BWC GROUP BASKETBALL STARTING DECEMBER 3rd & every Wednesday going
              forward! At JUMPSHOTZ GYM!
              <br />
              5:00PM - 5:45PM - (Littles) & 5:45PM - 6:30PM - (Bigs)
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ScheduleComponent;
